import _ from 'lodash';
import Device from '../Device';

const questions = [{
  model: 'sensi',
  type: 'oauth',
  name: 'sensi',
  label: 'step3OauthDeviceSensi',
  active: true,
  showNext: false,
  included: true,
  update: values => ({
    additionalFields: {
      type: 'sensi',
      tags: JSON.stringify(_.get(values, 'tags') || {}),
    },
  }),
}];

const addDevice = async (values, context, signup) => {
  const promise = new Promise((resolve, reject) => {
    signup.$root.$on('oauth.redirect', () => {
      resolve();
    });
  });
  signup.$root.$emit('oauth.submit', values, context);
  return promise;
};

const Sensi = new Device('sensi', { mfg: 'sensi', questions, addDevice });

export default Sensi;
